import React, { Fragment } from 'react';
import { Skeleton, SkeletonWrapper } from './atoms/skeleton';
const SkeletonLoader = props => {
    const length = props.length || 1;
    return (React.createElement(Fragment, null, Array.from({ length }).map((_, i) => (React.createElement(SkeletonWrapper, { key: i, ...props },
        React.createElement(Skeleton, { ...props }))))));
};
export default SkeletonLoader;
